import angular from 'angular'
import './product_categories.service'
import './product_subcategories/product_subcategories.controller'

angular
  .module('admin.product_categories', [
    'admin.product_categories.service',
    'admin.product_subcategories',
  ])
  .controller('ProductCategoriesCtrl', ProductCategoriesCtrl)

/** @ngInject */
function ProductCategoriesCtrl($state, $rootScope, ProductCategoriesService, MarketplaceService) {
  var vm = this

  vm.items = []
  vm.perPage = 25

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  MarketplaceService.list(0, 100).then(function (result) {
    vm.marketplaces = result.results
  })

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    ProductCategoriesService.list(vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.items = result.results
    })
  }

  load(1)

  vm.load = function () {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function (newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.go = function (item) {
    $state.go('admin.product_categories.product_subcategories', { parentId: item.id })
  }

  vm.add = function () {
    vm.app = {
      id: 0,
      t: '',
      txt: '',
      'id-mp': '',
    }

    if ($rootScope.whitelabel) {
      const mkt = vm.marketplaces.find((item) => item.host == $rootScope.whitelabelConfig.host)
      if (mkt) {
        vm.app['id-mp'] = mkt.id
      }
    }
    $('#myModalAdd').modal('show')
  }

  vm.edit = function (item) {
    vm.app = angular.copy(item)
    delete vm.app.ts
    delete vm.app['ts-m']
    $('#myModalAdd').modal('show')
  }

  vm.create = function () {
    if (!vm.app.t) {
      swal('Please enter a Title', '', 'error')
      return
    }

    ProductCategoriesService.save(vm.app).then(
      function () {
        $('#myModalAdd').modal('hide')
        load(1)
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.update = function () {
    if (!vm.app.t) {
      swal('Please enter a Title', '', 'error')
      return
    }

    ProductCategoriesService.update(vm.app.id, vm.app).then(
      function () {
        $('#myModalAdd').modal('hide')
        load(1)
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ProductCategoriesService.remove(item.id).then(
            function () {
              $('#myModalAdd').modal('hide')
              load(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }
}
